import { api } from './api';

export interface WorkspaceMember {
  id: string;
  email: string | null;
  name: string | null;
  pictureUrl: string | null;
  role: 'owner' | 'admin' | 'editor' | 'viewer';
}

/** A member's display label — name if set, otherwise email, otherwise the raw id. */
export function memberLabel(m: Pick<WorkspaceMember, 'name' | 'email' | 'id'>): string {
  return (m.name?.trim() || m.email?.trim() || m.id);
}

export type AssignableRole = 'admin' | 'editor' | 'viewer';

export const membersApi = {
  /** Members of the workspace's owning company. Backs the MemberPicker. */
  async list(wsId: string): Promise<WorkspaceMember[]> {
    const r = await api.get<WorkspaceMember[]>(`/api/workspaces/${wsId}/members`);
    return r.data;
  },
  /** Change a member's role (owner/admin only; owners are protected). */
  async setRole(wsId: string, userId: string, role: AssignableRole): Promise<void> {
    await api.patch(`/api/workspaces/${wsId}/members/${userId}`, { role });
  },
  /** Remove a member from the company (owner/admin only). */
  async remove(wsId: string, userId: string): Promise<void> {
    await api.delete(`/api/workspaces/${wsId}/members/${userId}`);
  },
};
